import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

class DeleteLicensee extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  Submit = () => {
    let id = this.props.DeleteItem && this.props.DeleteItem.userId.id;

    this.props.DeleteLicensee(id);
    this.props.closeDelModel();
    //this.props.resetPage();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showDelModel}
          animation={false}
          size="md"
          backdrop="static"
          onHide={this.props.closeDelModel}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Delete Licensee</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <div>
              <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                <b>Are you sure you want to delete?</b>
              </h6>
            </div>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  className="cmnDelCnclBtn"
                  variant="danger"
                  onClick={() => this.props.closeDelModel()}
                >
                  CANCEL
                </Button>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnDelOkBtn"
                  onClick={this.Submit}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DeleteLicensee;
